import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { prelimGlobalSearchResult } from './constants/globalSearch';
import { sortByAlpha } from '../../helpers/sorters';
import ContainerSearchItem from './ContainerSearchItem';
import { loadingBlock } from '../../helpers/notifications';
import GlobalExportModal from './GlobalExportModal';
import Icon from '../common/Icon';

const GlobalSearch = () => {
  const [value, setValue] = useState('');
  const [containers, setContainers] = useState([]);
  const [didSearch, setDidSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({ roles: [], admin: false });
  const [viewExportModal, setViewExportModal] = useState(false);

  const handlePrelimSearch = async () => {
    if (!value) return;
    setLoading(true);
    loadingBlock.add('.global-search-content');
    let result = await prelimGlobalSearchResult({ value });
    if (result.ok) {
      setContainers(sortByAlpha(result.data.containers, 'name'));
      setUser({ roles: result.data.roles, admin: result.data.admin });
    }
    if (result.status) {
      setLoading(false);
      setDidSearch(true);
      loadingBlock.remove('.global-search-content');
    }
  };

  const authorized = (containerID) => {
    return user.roles.map((r) => r.container_id).includes(containerID);
  };

  const resetSearchBox = () => {
    setValue('');
    setContainers([]);
    setDidSearch(false);
  };

  return (
    <>
      <header>
        <div className='breadcrumbs'>
          <ol>
            <li className='single-item'>
              <Link to='/manage'>
                <i className='fa-solid fa-arrow-left' /> Back to Containers
              </Link>
            </li>
          </ol>
        </div>
      </header>
      <div className='global-search details'>
        <p>
          Find submissions across all containers using an exact response value.
        </p>
        <p>
          <b>Note:</b> Search is limited to text field values.
        </p>
        {didSearch ? (
          <>
            <h3>
              Showing Results for: "{value}"
              <Icon
                onClick={resetSearchBox}
                title='Clear search value'
                icon='square-xmark fa-lg'
              />
            </h3>
          </>
        ) : (
          <>
            <input
              type='text'
              placeholder='Enter search value...'
              value={value}
              onChange={(e) => setValue(e.target.value)}
              disabled={loading}
              onKeyDown={(e) => e.key === 'Enter' && handlePrelimSearch()}
            />
            <button onClick={handlePrelimSearch} disabled={loading}>
              Search
            </button>
          </>
        )}
      </div>
      <div className='global-search-content details'>
        {didSearch && containers.length > 0 ? (
          <>
            <h2>Results by Container</h2>
            <div className='controls'>
              <button
                className='right'
                onClick={() => setViewExportModal(true)}
              >
                Export Results
              </button>
            </div>
            {containers.map((container) => (
              <ContainerSearchItem
                key={`c-${container.id}`}
                container={container}
                value={value}
                authorized={user.admin || authorized(container.id)}
              />
            ))}
            <GlobalExportModal
              viewExportModal={viewExportModal}
              setViewExportModal={setViewExportModal}
              containers={containers}
              authorizedContainers={
                user.admin
                  ? containers
                  : containers.filter((c) => authorized(c.id))
              }
              value={value}
            />
          </>
        ) : didSearch ? (
          <div>No results found...</div>
        ) : (
          <div>Enter a search term to begin...</div>
        )}
      </div>
    </>
  );
};

export default GlobalSearch;
